<ng-container *appIsGranted="['OTHERS', 'OTHERS_FILES_OTA', 'READ']">
  <div class="card">
    <div class="card align-items-center" *ngIf="circularProgressiveWait">
      <div card="card-body">
        <div class="spinner-border text-primary m-1" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div class="card-body">
      <!-- Nav tabs -->
      <ul
        ngbNav
        #customNav="ngbNav"
        [activeId]="1"
        class="nav nav-tabs nav-tabs-custom"
      >
        <li [ngbNavItem]="1">
          <a ngbNavLink>
            <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
            <span class="d-none d-sm-block">Arquivos</span>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="TabFiles"></ng-template>
          </ng-template>
        </li>
        <ng-container *appIsGranted="['OTHERS', 'OTHERS_FILES_OTA', 'READ']">
          <li [ngbNavItem]="2">
            <a ngbNavLink>
              <span class="d-block d-sm-none"
                ><i class="fa-automobile"></i
              ></span>
              <span class="d-none d-sm-block">OTA</span>
            </a>
            <ng-template ngbNavContent>
              <ng-template [ngTemplateOutlet]="TabOTA"></ng-template>
            </ng-template>
          </li>
        </ng-container>
      </ul>

      <!-- Tab panes -->
      <div class="tab-content p-3 text-muted">
        <div [ngbNavOutlet]="customNav"></div>
      </div>
    </div>
  </div>
  <ng-template #TabFiles>
    <div class="card overflow-auto">
      <div class="row">
        <div class="col-md-9"><h6>Arquivos</h6></div>
        <div
          class="col-md-3"
          *appIsGranted="['OTHERS', 'OTHERS_FILES', 'CREATE']"
        >
          <button class="btn btn-primary" (click)="openModal(modalInsertFile)">
            Novo arquivo
          </button>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-2">
              <label>Nome</label>
              <div class="mb-1 row">
                <input
                  class="form-control"
                  type="text"
                  id="name-input-text"
                  placeholder="Nome"
                  [(ngModel)]="filterName"
                  (change)="filterList()"
                />
              </div>
            </div>

            <div class="col-md-4">
              <label>Tipo de arquivo</label>

              <ng-select
                class="w-100 mb-3"
                id="fileTypeSelect"
                placeholder="Selecione um tipo de arquivo"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="filterFileType"
                (change)="getFiles(filterFileType)"
              >
                <ng-option *ngFor="let type of filesType" [value]="type.id">
                  {{ type.name }}
                </ng-option>
              </ng-select>
            </div>
            <div class="col-md-2">
              <label>Produção</label>
              <ng-select
                class="w-100 mb-3"
                id="situationSelect"
                placeholder="Arquivo de produção?"
                [(ngModel)]="filterFileProduction"
                (change)="filterList()"
              >
                <ng-option value="1"> Sim </ng-option>
                <ng-option value="0"> Não </ng-option>
              </ng-select>
            </div>
            <!-- <div class="col-md-3">
            <button type="submit" class="btn btn-sm btn-primary" (click)="filter()">
              Filtrar
            </button>
            <button type="submit" class="btn btn-sm btn-danger" (click)="filterClear()">
              Limpar Filtro
            </button> 
          </div>-->
          </div>
        </div>
      </div>
      <div class="card align-items-center" *ngIf="circularProgressiveWait">
        <div card="card-body mt-n3">
          <div class="spinner-border text-primary m-1" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h6>Lista dos arquivos - {{ returnFileTypeName(filterFileType) }}</h6>
        </div>
        <div class="card-body overflow-auto">
          <table class="table table-fit table-bordered table-hover">
            <thead class="table-primary">
              <tr>
                <th class="text-center col-md-1" scope="col">FileId</th>
                <th class="text-center" scope="col">FileType</th>
                <th class="text-center col-md-1" scope="col">FileSize</th>
                <th class="text-center col-md-1" scope="col">FileCRC</th>
                <th class="text-center" scope="col">Criado em</th>
                <th class="text-center" scope="col">Nome</th>
                <th class="text-center" scope="col">Descrição</th>
                <th class="text-center" scope="col">Produção</th>
                <th class="text-center" scope="col">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of filesFilter; let i = index">
                <td class="text-center" scope="row">{{ item.fileId }}</td>
                <td class="text-center" scope="row">
                  {{ returnFileTypeName(item.fileTypeId) }}
                </td>
                <td class="text-center" scope="row">
                  {{ round(item.fileSize / 1000, 2) }}KB /<br />
                  {{ round(item.fileSize / 1000000, 2) }}MB
                </td>
                <td class="text-center" scope="row">{{ item.fileCRC }}</td>
                <td class="text-center" scope="row">{{ item.createDate }}</td>

                <td class="text-center" scope="row">{{ item.name }}</td>
                <td class="text-center" scope="row">
                  {{ item.description != "null" ? item.description : "" }}
                </td>
                <td class="text-center" scope="row">
                  <input
                    #isProductionForm
                    class="form-check-input ms-2"
                    type="checkbox"
                    [(ngModel)]="item.production"
                    (change)="
                      changeProductionFlagFile(
                        item.fileId,
                        isProductionForm.checked
                      )
                    "
                    checked="true"
                    unchecked="false"
                  />
                  <!-- {{ item.production == 0 ? "Não" : "Sim" }} -->
                </td>
                <td scope="row">
                  <ng-container
                    *appIsGranted="['OTHERS', 'OTHERS_FILES', 'DELETE']"
                  >
                    <i
                      ngbTooltip="Inativar arquivo"
                      class="fa fa-trash ms-2"
                      style="color: red; cursor: pointer"
                      (click)="inactiveFile(item.fileId)"
                      aria-hidden="true"
                    ></i
                  ></ng-container>
                  <ng-container
                    *appIsGranted="['OTHERS', 'OTHERS_FILES_DOWNLOAD', 'READ']"
                  >
                    <i
                      ngbTooltip="Baixar arquivo"
                      style="cursor: pointer"
                      class="fa fa-download ms-2"
                      (click)="downloadFile(item.fileId)"
                      aria-hidden="true"
                    ></i
                  ></ng-container>
                  <ng-container
                    *appIsGranted="['OTHERS', 'OTHERS_FILES_SEND', 'CREATE']"
                  >
                    <i
                      ngbTooltip="Enviar arquivo"
                      class="uil-message ms-2"
                      [ngStyle]="{
                        display: !returnAllowedSendFileType(item.fileTypeId)
                          ? 'none'
                          : ''
                      }"
                      style="color: green; cursor: pointer"
                      aria-hidden="true"
                      (click)="
                        openModalSendFile(modalSendFileCommand, item.fileId)
                      "
                    >
                    </i>
                  </ng-container>

                  <ng-container
                    *ngIf="
                      ['FT_PROFILE', 'FT_MAXIO_CONFIG'].includes(
                        returnFileTypeName(item.fileTypeId) ?? ''
                      )
                    "
                  >
                    <i
                      ngbTooltip="Traduzir arquivo"
                      class="fa fa-language ms-2"
                      style="color: green; cursor: pointer"
                      aria-hidden="true"
                      (click)="
                        openModalTranslate(modalProfileFileTranslate, item)
                      "
                    >
                    </i>
                  </ng-container>
                </td>

                <!-- <td class="text-center" scope="row">
                <button class="btn btn-primary">
                  (click)="updateModal(item, modalUpdateItem)" Editar
                </button>
              </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #TabOTA>
    <div class="card overflow-auto">
      <div class="card-body">
        <div class="row">
          <div class="col-md-8">
            <label>Serial</label>
            <input #inputSerialOTA class="w-100" placeholder="205502151" />
          </div>
          <div class="col-md-2">
            <div class="d-flex">
              <input
                class="form-check-input ms-2"
                type="radio"
                name="formRadios"
                id="formRadios1"
                value="suntech"
                [(ngModel)]="statusOTAManufactor"
                checked
              />
              <label class="form-check-label" for="formRadios2">
                Suntech
              </label>
              <input
                class="form-check-input ms-2"
                type="radio"
                name="formRadios"
                id="formRadios2"
                value="maxtrack"
                [(ngModel)]="statusOTAManufactor"
              />
              <label class="form-check-label" for="formRadios2">
                Maxtrack
              </label>
            </div>
          </div>
          <div class="col-md-2">
            <div class="row w-75 ms-4">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                (click)="searchOTA(inputSerialOTA.value)"
              >
                Pesquisar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="card-body overflow-auto">
          <table class="table table-fit table-bordered table-hover">
            <thead class="table-primary">
              <tr>
                <th class="text-center col-md-1" scope="col">Serial</th>
                <th class="text-center col-md-1" scope="col">Status</th>
                <th class="text-center col-md-1" scope="col">
                  Data ultimo pacote enviado
                  <i
                    [ngClass]="
                      orderbytimestampOTAAsc ? 'uil-arrow-down' : 'uil-arrow-up'
                    "
                    aria-hidden="true"
                    style="cursor: pointer"
                    (click)="
                      orderByTimestamp();
                      orderbytimestampOTAAsc = !orderbytimestampOTAAsc
                    "
                  ></i>
                </th>
                <th class="text-center col-md-1" scope="col">
                  Versao Inicial - Versao Final
                </th>

                <th class="text-center" scope="col">Versao (fileId)</th>
                <th class="text-center col-md-1" scope="col">
                  Porcentagem
                  <i
                    [ngClass]="
                      orderbypercentAsc ? 'uil-arrow-down' : 'uil-arrow-up'
                    "
                    aria-hidden="true"
                    style="cursor: pointer"
                    (click)="
                      orderByPercent(); orderbypercentAsc = !orderbypercentAsc
                    "
                  ></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of statusOTA; let i = index">
                <td class="text-center" scope="row">{{ item.serial }}</td>
                <td class="text-center" scope="row">
                  {{ item.status }}
                </td>
                <td class="text-center" scope="row">
                  {{ decodeTimestamp(item.dataHoraUltimoPacoteRecebido) }}
                </td>
                <td class="text-center" scope="row">
                  {{ item.versaoInicial }} - {{ item.versaoFinal }}
                </td>
                <td class="text-center" scope="row">
                  {{ item.versao }} - ({{ item.fileId }})
                </td>
                <td class="text-center" scope="row">
                  <div *ngIf="item.porcentagem" class="d-flex">
                    <div class="progress-container">
                      <div
                        class="progress-bar"
                        [style.width]="item.porcentagem + '%'"
                        [ngStyle]="{
                          'background-color': getBarColor(item.porcentagem)
                        }"
                      ></div>
                    </div>
                    <span style="font-weight: bold">{{
                      item.porcentagem + "%"
                    }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Dialog Insert File -->
  <ng-template #modalInsertFile let-modal>
    <div class="modal-header">
      <h5 class="modal-title mt-0">Novo Arquivo</h5>
      <button
        type="button"
        class="btn btn-close"
        (click)="modal.dismiss('Cross click')"
        aria-hidden="true"
      ></button>
    </div>
    <div class="modal-body">
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-name">Nome</span>
        <input
          name="name"
          [(ngModel)]="newFile.name"
          type="text"
          class="form-control"
          required
          aria-describedby="inputGroup-name"
          [placeholder]="returnFilePlaceholder(newFile.fileTypeId)"
        />
      </div>
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-fileTypeId"
          >Tipo do arquivo
        </span>
        <ng-select
          class="w-100 mb-3"
          id="fileTypeSelect"
          placeholder="Selecione um tipo de arquivo"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="newFile.fileTypeId"
        >
          <ng-option
            *ngFor="let type of returnAllowedInsertFileType()"
            [value]="type.id"
          >
            {{ type.name }}
          </ng-option>
        </ng-select>
      </div>
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-file">Arquivo</span>
        <div class="form-horizontal w-100">
          <div class="form-group">
            <div class="row">
              <div class="col-md-9">
                <div class="mb-3">
                  <input
                    class="form-control"
                    type="file"
                    id="file"
                    [accept]="returnFileExtension(newFile.fileTypeId)"
                    (change)="selectFile($event)"
                  />
                </div>
              </div>
            </div>
            <div class="row minWidth" *ngIf="loadingFile">
              <img src="assets/images/carregando-1.gif" />
            </div>
          </div>
        </div>
      </div>
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-fileSizeId"
          >fileSize
        </span>
        <div class="form-group">{{ newFile.fileSize }} kb</div>
      </div>

      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-description"
          >Descrição</span
        >
        <div class="form-horizontal w-100">
          <div class="form-group">
            <textarea
              name="description"
              [(ngModel)]="newFile.description"
              maxlength="2500"
              class="form-control"
              rows="5"
            ></textarea>
          </div>
        </div>
      </div>
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="newFile.name.length < 1 && newFile.fileSize < 0"
        (click)="insertNewFile(); modal.dismiss('Cross click')"
      >
        Criar
      </button>
      <label *ngIf="newFile.name.length < 1" class="text-danger ms-3">
        Preencha o nome</label
      >
      <label *ngIf="newFile.fileSize == 0" class="text-danger ms-3">
        Insira o arquivo</label
      >
    </div>
  </ng-template>

  <!-- Dialog comando -->
  <ng-template #modalSendFileCommand let-modal>
    <div class="modal-header">
      <h5 class="modal-title mt-0">
        Enviar arquivo - {{ sendFileCommand.fileId }}
      </h5>
      <button
        type="button"
        class="btn btn-close"
        (click)="modal.dismiss('Cross click')"
        aria-hidden="true"
      ></button>
    </div>
    <div class="modal-body">
      <div class="column">
        <div>
          <label
            for="serial"
            class="col-md-1 col-form-label"
            style="margin-right: 20px"
          >
            Serial</label
          >
          <input
            placeholder="205502151;"
            [ngbTooltip]="sendFileCommand.seriais"
            [(ngModel)]="sendFileCommand.seriais"
            class="w-75"
          />
        </div>
        <div class="row">
          <div class="col-md-8">
            <label class="col-md-2 col-form-label"> Timeout </label>
            <div class="d-inline ms-4">
              <select [(ngModel)]="sendFileCommand.timeout">
                <option
                  *ngFor="let item of timeOutKeys; let i = index"
                  [value]="i"
                >
                  {{ item }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="align-middle">
          <button
            class="btn btn-success"
            type="submit"
            (click)="sendFile(); modal.dismiss()"
            [disabled]="sendFileCommand.seriais.length < 1"
          >
            Enviar
          </button>
          <label
            class="text-danger ms-3"
            *ngIf="sendFileCommand.seriais.length < 1"
            >Prencha o serial</label
          >
        </div>
      </div>
    </div>
  </ng-template>
  <!--Fim Dialog comando padrão -->

  <!-- Dialog Translate -->
  <ng-template #modalProfileFileTranslate let-modal>
    <div class="card align-items-center" *ngIf="circularProgressiveWait">
      <div card="card-body mt-n3">
        <div class="spinner-border text-primary m-1" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div class="modal-header">
      <h5 class="modal-title mt-0">{{ fileProfileName }}</h5>
      <button
        type="button"
        class="btn btn-close"
        (click)="modal.dismiss('Cross click')"
        aria-hidden="true"
      ></button>
    </div>

    <div class="modal-body">
      <div>
        <div class="col-md-2 d-inline">
          <input
            class="form-check-input ms-2"
            type="radio"
            name="formRadios"
            id="formRadios1"
            value="0"
            [(ngModel)]="prettyProfileFile"
            checked
          />
          <label class="form-check-label" for="formRadios1"> 0 </label>
          <input
            class="form-check-input ms-2"
            type="radio"
            name="formRadios"
            id="formRadios2"
            value="1"
            [(ngModel)]="prettyProfileFile"
          />
          <label class="form-check-label" for="formRadios2"> 1 </label>
          <input
            class="form-check-input ms-2"
            type="radio"
            name="formRadios"
            id="formRadios3"
            value="2"
            [(ngModel)]="prettyProfileFile"
          />
          <label class="form-check-label" for="formRadios2"> 2 </label>
        </div>
      </div>
      <div class="overflow-auto">
        <div class="card p-3">
          <div>
            <div *ngIf="prettyProfileFile == '0'">
              <ngx-json-viewer
                [json]="fileProfileContents"
                [depth]="8"
                [expanded]="true"
              ></ngx-json-viewer>
            </div>

            <div *ngIf="prettyProfileFile == '1'">
              <ngx-json-viewer
                [json]="fileProfileContents"
                [expanded]="false"
              ></ngx-json-viewer>
            </div>
            <div *ngIf="prettyProfileFile == '2'">
              <p [innerHTML]="fileProfileContents | json"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <!--Fim Dialog Translate-->
</ng-container>
